module.exports = __webpack_public_path__ + "img/qk.9942de60.png";